import React from 'react'

import { ProductV2 } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { ClashOfClansSubItem } from '@/features/storefronts/_storeBase/card/v2/OfferCard/games/clashofclans/components/ClashOfClansItem'
import { Grid } from '@/features/storefronts/_storeBase/card/v2/OfferCard/shared/ItemsGrid'
import { isStoreSpecial } from '@/features/storefronts/productFilters'

import styles from './ClashOfferContent.module.scss'

export const ClashOfferContent = ({ product }: { product: ProductV2 }) => {
  const t = useTranslations()
  const isStoreSpecialOffer = isStoreSpecial(product)
  const productCount = product.contents.length
  const styleMode = productCount === 4 ? 'TightGrid' : 'NormalGrid'
  const subItemStyle = product.contents.length > 2 ? 'SubItem' : 'SubItemLarge'

  return (
    <div className={styles.offerContentContainer}>
      <div className={styles.Subtitle}>{t('offers_included')}</div>
      <div className={cx(styles.ProductsContainer, styles[styleMode])}>
        <Grid gameId={'clashofclans'}>
          {product.contents.map((content, index) => (
            <div className={styles[subItemStyle]} key={`product-${product.id}-content-${index}`}>
              <ClashOfClansSubItem content={content} isStoreSpecial={isStoreSpecialOffer} />
            </div>
          ))}
        </Grid>
      </div>
    </div>
  )
}
